var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.369,
    height: 62.403,
    viewBox: "0 0 62.369 62.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-183.815 -238.799)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(195 250)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-211.925 -7.036) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "complete-ok-accept-good-tick-svgrepo-com_1_",
    "data-name": "complete-ok-accept-good-tick-svgrepo-com (1)",
    transform: "translate(357.958 295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M32,60A28,28,0,1,1,60,30.47a2,2,0,1,1-4,.22,24.092,24.092,0,1,0-2.42,11.82,2,2,0,1,1,3.59,1.75A27.78,27.78,0,0,1,40.91,58.55,28.14,28.14,0,0,1,32,60Z",
    fill: "#d34e4e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "failed-cancel-delete-remove-trash-svgrepo-com",
    transform: "translate(183 247.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M43,35.48a2,2,0,0,1-1.41-.59l-22-22a2,2,0,1,1,2.83-2.83l22,22A2.01,2.01,0,0,1,43,35.48Z",
    fill: "#d34e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M21,35.48a2,2,0,0,1-1.42-3.41l22-22a2,2,0,0,1,2.83,2.83l-22,22a2,2,0,0,1-1.41.58Z",
    fill: "#d34e4e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.96f550584f5c6f38d5ac104608067ff5.svg";
export { ForwardRef as ReactComponent };